import Model from './model.js';

export default class Residence extends Model
{
    constructor(id, personId, governorate, district=undefined, township=undefined, region=undefined, mahalleh=null, zoghagh=null, dar=null, closestResidential=null, latitude=null, longitude=null, housingType=undefined, ownershipType=undefined, note=null){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.governorate        = governorate;
        this.district           = district;
        this.township           = township;
        this.region             = region;
        this.mahalleh           = mahalleh;
        this.zoghagh            = zoghagh;
        this.dar                = dar;
        this.closestResidential = closestResidential;
        this.latitude           = latitude;
        this.longitude          = longitude;
        this.housingType        = housingType;
        this.ownershipType      = ownershipType;
        this.note               = note;

        this.init()
    }

    update(data){
        Object.assign(this, data)
    }
    
    mapToUpdate(){
        return {
            governorates_id:    this.governorate?.value ?? null,
            districts_id:       this.district?.value ?? null,
            townships_id:       this.township?.value ?? null,
            regions_id:         this.region?.value ?? null,
            mahalleh:           this.mahalleh ?? null,
            zoghagh:            this.zoghagh ?? null,
            dar:                this.dar ?? null,
            closestResidential: this.closestResidential ?? null,
            latitude:           this.latitude ?? null,
            longitude:          this.longitude ?? null,
            housingType_id:     this.housingType?.value ?? null,
            ownershipType_id:   this.ownershipType?.value ?? null,
            notes:              this.note ?? null,
        }
    }
}

